import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-canvas py-16 md:py-24" data-id="element-56" data-mp="15capavgsvj0g">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-57" data-mp="1jd51zqavs64x">
        {showUrgency && <CountdownPanel headline="El precio de lanzamiento vence en 48 horas" subtext="Después vuelve a $24.90 USD | Hoy: $13.90 USD + 3 bonos | Octubre es ahora" data-id="element-58" data-mp="1ee1wy5uwhzwy" />}

        <div className="mx-auto mt-14 max-w-narrow text-center" data-id="element-59" data-mp="1o43ml22wjqdz">
          <h2 className="font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-60" data-mp="1o5y7whi35kil">
            Tu Jornada Rosa no tiene que empezar desde una hoja en blanco
          </h2>

          <p className="mt-6 text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-61" data-mp="1x2gpixkv9lzv">
            Puedes pasar horas buscando ideas, diseñando materiales y pensando qué dinámica
            realizar. O puedes empezar con una estructura completa ya preparada.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-gray-500 md:text-xl" data-id="element-62" data-mp="x2zae8c1zv0q">
            50 tarjetas. Un diario de autocuidado. Una guía paso a paso. Materiales para regalar. Y 3
            bonos para organizar y facilitar la experiencia con mayor seguridad.{' '}
            <span className="font-display font-extrabold text-ink" data-id="element-63" data-mp="1b31k37a7ji4w">Todo en un único kit.</span>
          </p>

          <div className="mx-auto mt-9 w-fit rounded-2xl bg-white px-8 py-6 shadow-soft ring-1 ring-gray-200" data-id="element-64" data-mp="1fu05gla1z6f0">
            <p className="font-display text-4xl font-extrabold leading-none tracking-tight text-plum-700 md:text-5xl" data-id="element-65" data-mp="1ks1nd2vqszow">
              Hoy: {offer.price}
              <span className="ml-2 align-middle text-lg font-semibold text-gray-500" data-id="element-66" data-mp="1tu1742y56hvj">
                {offer.currency}
              </span>
            </p>
            <p className="mt-3 text-gray-500" data-id="element-67" data-mp="3qv70gb47286a">
              Valor regular: <span className="line-through" data-id="element-68" data-mp="3lw45jjhxhic1">{offer.listPrice} USD</span>
            </p>
          </div>

          <div className="mt-10" data-id="element-69" data-mp="3huxj0knqvky">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-70" data-mp="3j604x2d9xah">
              Acceder al Protocolo Octubre Rosa ahora
            </CtaButton>
          </div>

          <TrustIcons className="mt-8" data-id="element-71" data-mp="deznlbhmjb71" />
        </div>
      </div>
    </section>;
}